import { v4 as uuidv4 } from "uuid";
export class ToolModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.latestVersion = null;
        this.discription = null;
        this.url = null;
    }
}
export default class Tool extends ToolModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
